import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const ZellePayIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/zelle-icon.png" style={style} />
}
